export enum EIntegrationSettingsTab {
  MASTER = 'MASTER',
  API_KEY = 'API_KEY',
  CALLBACK = 'CALLBACK',
}

export enum ECallbackType {
  STATUS = 'STATUS',
  IN_MESSAGE = 'IN_MESSAGE',
  MESSAGE_MATCHER = 'MESSAGE_MATCHER',
  MESSAGE_MATCHER_CATEGORY_CHANGED = 'MESSAGE_MATCHER_CATEGORY_CHANGED',
  SHORT_LINK_VISITED = 'SHORT_LINK_VISITED',
  SENDER_STATUS = 'SENDER_STATUS',
}

export type TCallbackType = keyof typeof ECallbackType;

export enum EApiKeyType {
  OUT_MESSAGES = 'out-messages',
  IN_MESSAGE = 'in-message',
  MESSAGE_HISTORY = 'message-history',
  MESSAGE_MATCHERS = 'message-matchers',
  CALLBACK = 'callback',
  CHANNEL_PROFILE = 'channel-profile',
  CASCADE = 'cascade',
  CHATBOTS = 'chatbots',
}

export type TApiKeyType = keyof typeof EApiKeyType;

export type TMasterApiKeyData = {
  id: number;
  apiKey: string;
  locked: boolean;
  name?: string;
  validUntil?: string | number | Date | null;
};

export type TApiKeyData = TMasterApiKeyData & {
  name: string;
  subjectIds: number[];
  permissions?: TApiKeyType[];
};

export type TMasterCallbackUrl = {
  id?: number;
  locked?: boolean;
  type: TCallbackType;
  url: string;
};

export type TCallbackUrl = {
  id: number;
  name: string;
  locked: boolean;
  types: TCallbackType[];
  urls: string[];
  subjectIds: number[];
};

export type TCallbackAuth = {
  id: number;
  activated: boolean;
  callbackId?: number;
};

export enum ECompanyDataErrors {
  LICENSE_NOT_FOUND = 'license.not-found',
  BALANCE_NOT_FOUND = 'balance.not-found',
  CALLBACK_URL_INCORRECT = 'callback.url.incorrect',
  APIKEY_NOT_FOUND = 'apikey.not-found',
}
